import { render, staticRenderFns } from "./modal-detail.vue?vue&type=template&id=27324230&scoped=true"
import script from "./modal-detail.vue?vue&type=script&lang=js"
export * from "./modal-detail.vue?vue&type=script&lang=js"
import style0 from "./modal-detail.vue?vue&type=style&index=0&id=27324230&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27324230",
  null
  
)

export default component.exports